import configureStore from './configureStore';

let store;

const getStore = initialState => {
  if (!store && initialState) {
    store = configureStore(initialState);
  }

  return store;
};

export default getStore;
